import { BuildingCreatableInterface } from '../interfaces/building-creatable.interface';
import { BuildingDto } from './building.dto';
import { IntersectionType, PartialType, PickType } from '@nestjs/swagger';

export class BuildingCreateDto
  extends IntersectionType(
    PickType(BuildingDto, ['number', 'subdivisionId']),
    PartialType(PickType(BuildingDto, ['notes'])),
  )
  implements BuildingCreatableInterface {}
